export default {
    methods: {
        getTiptapBlockColors() {
            //return ['rgb(98, 36, 131)', 'rgb(236, 32, 120)', 'rgb(98, 165, 20)'];
            // #AFCEED in rgb
            return ['rgb(175, 206, 237)'];
        },
        getTiptapBlockStylingString() {
            return 'padding: 16px; padding-top: 4px; padding-bottom: 1px; border-radius: 4px; margin-bottom: 16px;';
        },
        getTiptapBlockStylingObject(el) {
            //console.log('getTiptapBlockStylingObject', el.style.backgroundColor)
            //if (el.style.backgroundColor == 'rgb(98, 165, 20)') {
                //el.style.color = 'white';
            //     }
            //     else {
            //         el.style.color = 'black';
            // }
            el.style.padding = '16px';
            el.style.paddingTop = '4px';
            el.style.paddingBottom = '1px';
            el.style.borderRadius = '4px';
            el.style.display = 'block';
            el.style.marginBottom = '16px';
            //console.log('getTiptapBlockStylingObject', el)
            return el;
        },

        getHeadingLevels() {
            return [2];
        },

        getTiptapHeadingStylingString(h) {
            // console.log('custom getTiptapHeadingStylingString', h)
            switch(h) {
                // case 1:
                //     return 'color:#ff0000;';
                // case 2:
                //     return 'color:#00ff00;';
                // case 3:
                //     return 'color:#0000ff;';
            }
            return 'color:#b22222; margin-block-start: 0; margin-block-end: 0;';
        },
    }
}